import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Chip,
  Tooltip,
  IconButton,
} from '@mui/material';
import { motion } from 'framer-motion';
import DiscountIcon from '@mui/icons-material/Discount';
import { AddCircle, DeleteRounded, EditSquare, Star } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import AddSubscriptionPlan from './AddSubscriptionPlan';
import ModalView from '../model/ModelView';

const OfferCard = ({ plan, userInfo, onSuccess }) => {
  const navigate = useNavigate();
  const [openForm, setOpenForm] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleCreate = (plan) => {
    console.log("Add clicked:", plan);
    navigate('/coupon', {
      state: {
        plan,
        // coupon
      },
    });
  };

  const handleUpdate = (planId) => {
    console.log(planId);
    setOpenForm(true);
    setSelectedId(planId);
  };

  const handleDelete = (plan) => {
    console.log(plan);

  }

  const handleClose = () => {
    setOpenForm(false);
  };

  const subscribe = (plan) => navigate('/checkout', { state: { plan } });

  return (<>
    <motion.div
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.4 }}
      style={{ margin: '1rem auto', maxWidth: 360 }}
    >
      <Card
        // sx={{
        //   borderRadius: 1,
        //   boxShadow: 1,
        //   height: "380px",
        //   overflow: 'hidden',
        //   backgroundColor: "#011344",
        //   // background: 'linear-gradient(to right, #413502ff, #fdb307ff)',
        //   transition: "transform 0.3s",
        //   "&:hover": {
        //     transform: "scale(1.0)", //bgcolor: '#f7f7f7', color: '#000',
        //   },
        //   position: 'relative',
        //   backdropFilter: 'blur(8px)',
        // }}
        sx={{
          borderRadius: 1,
          boxShadow: 1,
          minHeight: 380,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          backgroundColor: "#011344",
          position: "relative",
        }}
      >
        {plan?.coupon && (
          <Box
            sx={{
              position: 'absolute',
              top: 20,
              right: -45,
              transform: 'rotate(45deg)',
              bgcolor: 'secondary.main',
              px: 6,
              py: 0.5,
              color: '#fff',
              fontWeight: 'bold',
              fontSize: 16,
              zIndex: 1,
              textTransform: 'uppercase',
            }}
          >
            {plan?.coupon?.codename}
          </Box>
        )}

        {userInfo?.roles === 'SUPERADMIN' && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              // height:'35px',
              left: 0,
              // bgcolor: 'secondary.main',
              zIndex: 1,
            }}
          >
            <Tooltip title="Add coupon">
              <IconButton sx={{ color: "white" }} onClick={() => handleCreate(plan)}>
                <AddCircle />
              </IconButton>
            </Tooltip>
            <Tooltip title="Add coupon">
              <IconButton sx={{ color: "white" }} onClick={() => handleUpdate(plan)}>
                <EditSquare />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton color="error" onClick={() => handleDelete(plan.id)}>
                <DeleteRounded />
              </IconButton>
            </Tooltip>
          </Box>
        )}

        <CardContent sx={{
          p: 4,
          color: "white",
          display: "flex",
          flexDirection: "column",
          height: "100%"
        }}>
          <Typography variant="h5" fontWeight={700} gutterBottom >
            {plan.name}
          </Typography>

          <Typography variant="h4" color="#8a6302ff"
            fontWeight={600} >
            ₹{plan.price}
            {/* <Typography variant="body2" component="span" ml={1} fontWeight={600}>
              / {plan.durationInMonths} month(s)
            </Typography> */}
            <Typography variant="body2" component="span" ml={1} fontWeight={600}>
              {plan.durationInDays}day(s)
            </Typography>
          </Typography>

          <Box my={2} >
            {plan?.features?.map((f, i) => (
              <Typography key={i} variant="body2" >
                ✅ {f}
              </Typography>
            ))}
          </Box>

          {plan?.coupon && (<>
            {plan?.coupon.discountPercentage && (
              <Chip
                icon={<DiscountIcon />}
                label={`${plan?.coupon.discountPercentage}% OFF - valid till ${plan?.coupon.validTill}`}
                color="warning"
                sx={{ my: 1 }}
              />
            )}
            {plan?.coupon?.discountAmount && (
              <Chip
                icon={<DiscountIcon />}
                label={`${plan?.coupon.discountAmount} FLAT OFF - valid till ${plan?.coupon.validTill}`}
                color="warning"
                sx={{ my: 1 }}
              />)}
          </>
          )}

          {plan.name.toLowerCase().includes("premium") && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: -46,
                // transform: 'rotate(45deg)',
                // bgcolor: 'secondary.main',
                px: 6,
                py: 0.5,
                color: '#fff',
                fontWeight: 'bold',
                fontSize: 12,
                zIndex: 1,
              }}
            >
              <Chip icon={<Star />} label="Premium" color="warning" size="small" />
            </Box>
          )}
          <Box sx={{ mt: "auto" }}
          // sx={{ position: 'absolute', bottom: 10,right:10 }}
          >
            {/* <motion.div
            whileHover={{ scale: 1.02 }}
            animate={{ y: [0, -2, 0], transition: { repeat: Infinity, duration: 2 } }}
          > */}
            {plan?.active && (
              <Button
                onClick={() => subscribe(plan)}
                fullWidth
                variant="contained"
                size="large"
                sx={{
                  mt: 1, bgcolor: "#011344", "&:hover": {
                    transform: "scale(1.0)", bgcolor: '#000',
                  },
                }}
              >
                Apply now
              </Button>
            )}
            {/* </motion.div> */}
          </Box>
        </CardContent>
      </Card>
    </motion.div>

    <ModalView
      open={openForm}
      handleClose={handleClose}
      title={selectedId ? "✏️ Update Subscription Plan" : "➕ Add Subscription Plan"}
      content={<AddSubscriptionPlan planId={selectedId} onSuccess={() => {
        setOpenForm(false);
        if (onSuccess) onSuccess();
      }
      } />}
    />

  </>
  );
};

export default OfferCard;
